import { z } from 'zod';

// Dashboard rows are dynamic dataframe records whose keys are verbatim backend
// column names (e.g. 'Campaign Name', 'CATEGORY_NAME', 'Cost Based Metric').
// The dashboard endpoints are declared with `camelCaseBody: false`, so these
// keys must NOT be camelCased — the schemas below validate the RAW shape.

// We will refactor snake case params when we understand how should work feature
// Current state of dashboard feature - code fully generated by Alessandro via AI
export const DashboardRowSchema = z.record(z.string(), z.unknown());

export const OverviewResponseSchema = z.object({
  brands_and_geo: z.array(DashboardRowSchema),
  campaign_summary: z.array(DashboardRowSchema),
  weekly_spend: z.array(DashboardRowSchema),
  active_channels: z.array(DashboardRowSchema),
});

export const DetailResponseSchema = z.object({
  pacing: z.array(DashboardRowSchema),
  budget_allocations: z.array(DashboardRowSchema),
  metrics: z.array(DashboardRowSchema),
  mediaplan: z.array(DashboardRowSchema),
  brands_and_geo: z.array(DashboardRowSchema),
  recommendations: z.array(DashboardRowSchema),
});

export const FinRecResponseSchema = z.object({
  campaign_results: z.array(DashboardRowSchema),
});

// Title-cased keys kept verbatim (passthrough). `.loose()` preserves any extra
// columns the backend may add without dropping them.
export const MetricTimeSeriesRowSchema = z
  .object({
    Channel: z.string(),
    Platform: z.string(),
    Date: z.string(),
    Metric: z.string(),
    Value: z.number(),
    'Cost Based Metric': z.string().nullable(),
    'Daily Spend': z.number(),
  })
  .loose();
